import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { GlobalService } from '../../../../services/global.service';

import { Observable } from 'rxjs/Observable';
import { catchError, finalize, map, filter, flatMap } from 'rxjs/operators';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-thread-list',
  templateUrl: './thread-list.component.html',
  styleUrls: ['./thread-list.component.css']
})
export class ThreadListComponent implements OnInit {

  @Output('selectThread') selectThread = new EventEmitter();
  
  constructor(
    public _globalService: GlobalService,
    public _chatService: ChatService
  ) { }

 
  ngOnInit() {
    // console.log('current auth', this._globalService._fireAuth.auth.currentUser);
    this.getThreadList();
  } 

  getThreadList() {

    const user_thread_path = this._globalService.root_path + '/'
      + this._globalService.domain + '/users/'
      + this._globalService._fireAuth.auth.currentUser.uid + '/threads';

    // console.log(user_thread_path);

    // First get all the thread ids from particular user
    this._globalService.user_thread_subscription =
      this._globalService._fireDB.list(user_thread_path)
        .stateChanges(['child_added', 'child_changed', 'child_removed'])
        .subscribe((thread: any) => {
          // console.log('thread', thread, thread.payload.val());

          if (thread.type === 'child_added') {

            const master_thread_path = this._globalService.root_path + '/'
              + this._globalService.domain + '/threads/' + thread.key;

            // Subscribe each thread
            this._globalService.master_thread_subscription[thread.key] =
              this._globalService._fireDB.object(master_thread_path)
                .snapshotChanges()
                .subscribe((thread_snap: any) => {
                  const thread_detail = thread_snap.payload.val();
                  // console.log('thread_detail  ', thread_detail);

                  // for individual thread
                  if (thread_detail.details.type === 0) {

                    // check if thread is availabe in component variable
                    const tdi = this._globalService.individual_thread_list.findIndex(data => data.thread_id === thread_snap.key);
                    if (tdi >= 0) {
                      this._globalService.individual_thread_list[tdi].last_message_added = thread_detail.details.last_message_added;
                      // console.log('last message added');
                      this.getSortedThreadList();
                    } else {

                      // get other user of thread
                      let other_user_id;
                      for (const userid in thread_detail.users) {
                        if (userid !== this._globalService._fireAuth.auth.currentUser.uid) {
                          other_user_id = userid;
                          break;
                        }
                      }
                      if (other_user_id) {

                        // subscribe to other user for real time update
                        const other_user_path = this._globalService.root_path + '/'
                          + this._globalService.domain + '/users/' + other_user_id;

                        this._globalService.master_user_subscription[thread.key] =
                          this._globalService._fireDB.object(other_user_path)
                            .valueChanges()
                            .subscribe((other_user: any) => {
                              // console.log('other_user  ', other_user);

                              const ui = this._globalService.individual_thread_list.findIndex(data => data.user_id === other_user_id);
                              if (ui >= 0) {
                                this._globalService.individual_thread_list[ui].user_name = other_user.meta.name;
                                this._globalService.individual_thread_list[ui].picture_thumbnail = other_user.meta.pictureURLThumbnail;
                                this._globalService.individual_thread_list[ui].online = other_user.online;
                              } else {
                                const thread_object = {
                                  thread_id: thread.key,
                                  thread_type: thread_detail.details.type,
                                  unseen_count: thread.payload.val().unseenCount,
                                  last_message_added: thread_detail.details.last_message_added,
                                  creater_id: thread_detail.details.creator_entity_id,
                                  user_name: other_user.meta.name,
                                  user_id: other_user.authentication_id,
                                  online: other_user.online,
                                  picture_thumbnail: other_user.meta.pictureURLThumbnail
                                };
                                this._globalService.individual_thread_list.push(thread_object);
                                this.getSortedThreadList();
                              }

                            });
                      }
                    }
                  }
                  // end
                  // for group thread
                  if (thread_detail.details.type !== 0) {

                  }
                  // end



                });

          } else if (thread.type === 'child_changed') {
            const fin = this._globalService.individual_thread_list.findIndex(data => data.thread_id === thread.key);
            if (fin >= 0) {
              this._globalService.individual_thread_list[fin].unseen_count = thread.payload.val().unseenCount;


              // web notification
              if (this._globalService.individual_thread_list[fin].unseen_count && (!this._globalService.selected_thread ||
                this._globalService.selected_thread.thread_id !== this._globalService.individual_thread_list[fin].thread_id)) {
                this._globalService.webNotification(this._globalService.individual_thread_list[fin].user_name,
                  'You have new message', this._globalService.individual_thread_list[fin].picture_thumbnail);
              }
              // end

            }

            if (this._globalService.selected_thread) {
              this._globalService.updateUnseenCount(this._globalService.selected_thread.thread_id,
                this._globalService._fireAuth.auth.currentUser.uid, 0);
            }
          }

        });

  }

  getSortedThreadList() {
    this._globalService.individual_thread_list.sort((a: any, b: any) => {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return b.last_message_added - a.last_message_added;
    });
  }

  onSelectThread(th) {
    // console.log(th);
    if (this._globalService.selected_thread) {
      if (this._globalService.selected_thread !== th) {
        this.selectThread.emit(th);
      }
    } else {
      this.selectThread.emit(th);
    }
  }

}





// WEBPACK FOOTER //
// ./src/app/pages/chat/sub-components/thread-list/thread-list.component.ts